import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        employees: '=',
        classifiers: '='
    },
    template: `
        <div class="heading01 type01">
            <h2>{{ 'dashboard.Scheduled courses' | translate }}</h2>
            <a class="btn add" ui-sref="authorized.planning.calendar()"
                ng-if="vm.PrivilegeService.canViewPlanning() && vm.PrivilegeService.canViewCourses()" >
                {{ 'dashboard.View all' | translate }}
            </a>
        </div>
        <div class="colholder mt1em tablet-block tablet-wrap">
            <div class="col col02 fixed">
                <div ng-if="vm.calendar">
                    <a class="btn discrete" ng-click="vm.calendar=false;"
                    >{{ 'dashboard.Pick a date range' | translate }}</a>
                    <div ng-if="vm.showCalendar" uib-datepicker class="inline" ng-model="vm.filter.startDate" datepicker-options="vm.options"></div>
                    <ul class="datepicker-legend">
                        <li class="color01">Classroom</li>
                        <li class="color02">Webinar</li>
                    </ul>
                </div>
                <div ng-if="!vm.calendar" class="form">
                    <a class="btn discrete" ng-click="vm.calendar=true;vm.updateEvents()"
                    >{{ 'dashboard.Pick a single date' | translate }}</a>
                    <div class="row">
                        <div class="items">
                            <label class="label small">{{ 'general.From' | translate }}</label>
                            <datepicker ng-model="vm.filter.startDate"></datepicker>
                        </div>
                    </div>
                    <div class="row">
                        <div class="items">
                            <label class="label small">{{ 'general.To' | translate }}</label>
                            <datepicker ng-model="vm.filter.enteringDate"></datepicker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col col05">
                <home-schedule-filter
                    events="vm.events"
                    all-events="vm.allEvents"
                    counts="vm.counts"
                    type="vm.type"
                    filter="vm.filter"
                    classifiers="vm.classifiers"
                    apply-filter="vm.applyFilter()"
                />
            </div>
        </div>
        <list-empty list="vm.events" show-add-message="false"></list-empty>
        <div class="tablewrapper">
            <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.events.length">
                <thead>
                    <tr>
                        <th>{{ 'dashboard.Training' | translate}}</th>
                        <th>{{ 'dashboard.Field' | translate }}</th>
                        <th>{{ 'dashboard.Type' | translate }}</th>
                        <th>{{ 'dashboard.Participants' | translate }}</th>
                        <th>{{ 'dashboard.Date' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="event in vm.events">
                        <td>
                            <a
                                ng-if="vm.PrivilegeService.canManageCourses()"
                                ui-sref="authorized.courses.courses.edit.occurrence.edit.general({id: event.courseId, occurrenceId: event.occurrenceId})"
                                >{{ event.title }}</a>
                            <span ng-if="!vm.PrivilegeService.canManageCourses()">{{ event.title }}</span>
                        </td>
                        <td>{{ event.courseFields }}</td>
                        <td>{{ vm.COURSE_TRAINING_TYPE_ENUM.LABELS[event.type] }}</td>
                        <td>{{ event.participantCount }}</td>
                        <td>{{ vm.getEventTime(event) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    `
})
export default class {
    constructor ($scope, moment, lodash, DATATABLES, TokenService, PrivilegeService, CalendarService, COURSE_TRAINING_TYPE_ENUM, DATE_ENUM) {
        this.$scope = $scope;
        this.moment = moment;
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.PrivilegeService = PrivilegeService;
        this.CalendarService = CalendarService;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.DATE_ENUM = DATE_ENUM;
        this.activeLanguage = TokenService.getActiveLanguage();
    }

    $onInit () {
        this.calendar = true;
        this.type = 'all';
        this.counts = { all: 0 };
        this.counts[this.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM] = 0;
        this.counts[this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE] = 0;
        this.counts[this.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST] = 0;
        this.allEvents = [];
        this.events = [];
        this.filter = { startDate: new Date(), endDate: new Date() };
        this.$scope.$watch('vm.filter.startDate', (newValue, oldValue) => {
            // check if calendar view
            if (this.calendar) {
                this.filter.endDate = angular.copy(this.filter.startDate);
                // update calendar classes only when changing between months
                if (!this.moment(newValue).isSame(this.moment(oldValue), 'month')) {
                    this.showCalendar = false;
                }
            }
            this.updateEvents();
        });
        const { $ } = window;

        $(document).on('click', '.uib-left', (event) => {
            // check if we have year picker or month picker
            const closestTable = $(event.target).closest('table');
            if (closestTable && !$(closestTable).hasClass('uib-daypicker')) {
                return;
            }

            this.filter.startDate = this.moment(this.filter.startDate).subtract(1, 'months').startOf('month').toDate();
            this.filter.endDate = angular.copy(this.filter.startDate);
            this.filter.endDate = this.moment(this.filter.endDate).endOf('month').toDate();

            this.updateEvents();
        });

        $(document).on('click', '.uib-right', () => {
            // check if we have year picker or month picker
            const closestTable = $(event.target).closest('table');
            if (closestTable && !$(closestTable).hasClass('uib-daypicker')) {
                return;
            }

            this.filter.startDate = this.moment(this.filter.startDate).add(1, 'months').startOf('month').toDate();
            this.filter.endDate = angular.copy(this.filter.startDate);
            this.filter.endDate = this.moment(this.filter.endDate).endOf('month').toDate();

            this.updateEvents();
        });

        $(document).on('click', '.uib-month', () => {
            const monthAndYearString = $('.uib-title').text().replace(/<\/?[^>]+(>|$)/g, '');

            const monthAndYearArray = monthAndYearString.split(' ');

            this.filter.startDate = this.moment(`${monthAndYearArray[1]}-${this.DATE_ENUM[this.activeLanguage][monthAndYearArray[0]]}-01`).toDate();
            this.filter.endDate = angular.copy(this.filter.startDate);
            this.filter.endDate = this.moment(this.filter.endDate).endOf('month').toDate();

            this.updateEvents();
        });
    }

    initDatePickerOptions (events) {
        this.options = {
            customClass: (data) => data.mode === 'day' ? this.getDayClass(this.moment(data.date), events) : '',
            showWeeks: false,
            startingDay: 1
        };
    }

    getDayClass (day, events) {
        const classes = [];
        for (let i = 0; i < events.length; i++) {
            const start = this.moment(events[i].start);
            const end = this.moment(events[i].end);
            // last parameter means it can be same as start|end dates
            if (day.isBetween(start, end, 'day', '[]')) {
                classes.push(events[i].className);
            }
        }
        // glue unique classes together
        return this.lodash.uniq(classes).join(' ');
    }

    updateEvents () {
        const { CalendarService, filter, moment } = this;
        const filterStart = moment(filter.startDate);
        const filterEnd = moment(filter.endDate);
        CalendarService.updateEvents(this.getApiFilter(), (events) => {
            if (this.calendar) {
                this.showCalendar = true;
                this.initDatePickerOptions(events);
                if (filterStart.isSameOrBefore(filterEnd)) {
                    this.allEvents = events.filter((event) => {
                        const eventStart = moment(event.start);
                        const eventEnd = moment(event.end);
                        const startInRange = filterStart.isBetween(eventStart, eventEnd, 'day', '[]');
                        const endInRange = filterEnd.isBetween(eventStart, eventEnd, 'day', '[]');
                        return startInRange || endInRange;
                    });
                }
            }
            else {
                this.allEvents = events;
            }
            this.updateTypeCounts();
            this.filterEventsByType();
        }, true);
    }

    applyFilter () {
        this.showCalendar = false;
        this.updateEvents();
    }

    getApiFilter () {
        const { CalendarService, filter, moment } = this;
        const apiFilter = angular.copy(filter);
        if (this.calendar) {
            // set apiFilter.startDate as 1st of month and endDate as last of month
            apiFilter.startDate.setDate(1);
            apiFilter.endDate = moment(angular.copy(apiFilter.startDate)).endOf('month').toDate();
        }
        apiFilter.startDate = CalendarService.getDateInRequestApiFormat(apiFilter.startDate);
        apiFilter.endDate = CalendarService.getDateInRequestApiFormat(apiFilter.endDate);
        return apiFilter;
    }

    getEventTime (event) {
        if (event.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE) {
            return this.moment(event.start).format('DD.MM.YYYY');
        }
        else if (event.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK) {
            return this.moment(event.start).format('DD.MM.YYYY HH:mm');
        }
        else if (event.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST) {
            return `${this.moment(event.start).format('DD.MM HH:mm')} - ${this.moment(event.end).format('DD.MM.YYYY')}`;
        }
        return `${this.moment(event.start).format('DD.MM HH:mm')} - ${this.moment(event.end).format('DD.MM HH:mm')}`;
    }

    updateTypeCounts () {
        this.counts.all = this.allEvents.length;
        this.lodash.forEach(this.COURSE_TRAINING_TYPE_ENUM.KEYS, (key) => {
            this.counts[key] = (this.allEvents.filter(
                (event) => event.type === key)).length;
        });
    }

    filterEventsByType () {
        this.events = this.type === 'all' ? this.allEvents : this.allEvents.filter((event) => event.type === this.type);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home/schedule/index.js